<template>
  <div class="container--login">
    <Head title="Login Page" />
    <div id="login" v-if="step">
      <img src="/img/04_Subit_logo_B.png" alt="logo_menu" class="logo" style="width: 280px" />
      <div id="login_box">
        <form action="" method="post" class="login_form" onsubmit="return false;" @submit.prevent="submit">
          <dl>
            <div class="lf_email">
              <dt>
                <label for="email" value="Email">Email</label>
              </dt>
              <dd>
                <input type="text" name="email" v-model="email" placeholder="Email" id="email" />
              </dd>
            </div>
            <div class="lf_pass">
              <dt>
                <label for="password" value="Password">Password</label>
              </dt>
              <dd>
                <input type="password" name="password" v-model="password" placeholder="Password" id="password" />
              </dd>
            </div>
            <div class="fp">
              <a href="reissue-password">パスワードをお忘れですか？</a>
            </div>
            <div class="lf_submit">
              <input type="submit" value="Login" id="sb" class="btn" v-on:click="firstAuth" />
            </div>
          </dl>
        </form>
      </div>
    </div>
    <div id="login" v-if="step2">
      <img src="/img/04_Subit_logo_B.png" alt="logo_menu" class="logo" style="width: 280px" />
      <div id="login_box">
        <form action="" method="post" class="two_auth" onsubmit="return false;">
          <dl>
            <p style="font-weight: 500">認証コードを入力してください．</p>
            <div class="lf_code">
              <dt>
                <label for="code">Code</label>
              </dt>
              <dd>
                <input type="text" name="code" v-model="code" placeholder="code" id="code" />
              </dd>
            </div>
            <div class="fp">
              <u v-on:click="resendMail">認証コードを再発行する</u>
            </div>
            <div class="lf_submit">
              <input type="submit" value="Login" v-on:click="secondAuth" id="sb" class="btn" />
            </div>
          </dl>
        </form>
      </div>
    </div>
  </div>
</template>
<style lang="css">
* {
  padding: 0;
  margin: 0;
}

.close_btn {
  float: right;
  margin: 10px;
  width: 70px;
}

.error_box {
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(1, 1, 1, 0.3);
}

.eb {
  border: solid black;
  background: #fffbf9;
  width: 350px;
  height: 160px;
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translate(-50%);
}

.eb p {
  margin: 0;
  padding: 10px;
  font-size: small;
  font-weight: 300;
}

.error {
  background: #d20000;
  color: white;
}

.fp {
  text-align: center;
}

.fp a {
  opacity: 0.5;
  color: white;
}

.fp u {
  cursor: pointer;
  opacity: 0.5;
  color: #333;
}

input::placeholder {
  text-align: center;
}

#email,
#password {
  width: 280px;
}

#code {
  width: 280px;
}

#sb {
  width: 280px;
  margin: 15px 0;
  background: #183e7a;
  border-radius: 30px;
  color: white;
  font-weight: bold;
}

.active {
  display: block;
}

.lf_rm {
  position: relative;
}

.lf_submit {
  float: right;
}

.logo {
  display: block;
  margin: 0 auto;
}

.body {
  width: 100%;
  height: 100%;
  position: relative;
}

#login {
  position: absolute;
  color: white;
  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);
}

#login_box {
  padding: 12px 10px 10px 10px;
  width: 300px;
  height: 200px;
}
</style>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import Email from '@/Pages/Components/validateEmail.js';
import Password from '@/Pages/Components/validatePassword.js';

export default {
  data() {
    return {
      email: '',
      password: '',
      code: '',
      recovery_code: '',
      userId: -1,
      isActive: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      width: window.innerWidth,
      height: window.innerHeight,
      step: true,
      step2: false,
    };
  },
  methods: {
    firstAuth() {
      try {
        Email.isInvalid(this.email);
        Password.isInvalid(this.password);
        axios
          .post('/login/first', {
            email: this.email,
            password: this.password,
          })
          .then((res) => {
            const result = res.data.result;
            const twoauth = res.data.twoauth;
            if (result) {
              if (twoauth) {
                location.href = '/file_translate';
              } else {
                this.step = false;
                this.step2 = true;
                this.userId = res.data.user_id;
                alert('認証コードをメールで送信しました。');
              }
            } else {
              location.href = '/file_translate';
            }
          })
          .catch((err) => {
            if (err.response.data.error_message !== undefined) {
              alert(err.response.data.error_message);
            } else {
              alert('メールアドレスまたはパスワードが異なります．');
            }
          });
      } catch (error) {
        alert(error.message);
      }
    },
    secondAuth() {
      let peg = /[0-9]{4}$/;
      if (!peg.test(this.code)) {
        alert('コードの長さもしくは使用された文字列にエラーが含まれています');
      } else {
        axios
          .post('/login/second', {
            code: this.code,
            user_id: this.userId,
          })
          .then((res) => {
            console.log(res);
            const result = res.data.result;
            if (result) {
              location.href = '/file_translate';
            } else {
              alert('2段階認証コードが正しくありません。');
            }
          })
          .catch((err) => {
            console.log(err);
            alert('メールアドレスまたはパスワードが異なります．');
          });
      }
    },
    resendMail() {
      alert('メール送信中');
      axios
        .post('/login/resend', {
          email: this.email,
        })
        .then((res) => {
          alert('認証コードをメールで再送信しました。');
        })
        .catch((err) => {
          alert('メールアドレスまたはパスワードが異なります．');
        });
    },
    mounted: function () {
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize);
    },
  },
};
</script>
